import { render } from "./Success.vue?vue&type=template&id=e6ae1a9a&ts=true"
import script from "./Success.vue?vue&type=script&lang=ts"
export * from "./Success.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ishii_tat_wsl/ghq/github.com/whi-product/ams-bot/company-oauth-success-screen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__